import React from 'react';
import {Container} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Link from "./link.js";
import Grid from "@material-ui/core/Grid";

export default (props) =>
{
    const styles =
              {
                  paddingTop:      50,
                  paddingBottom:   50,
                  textAlign:       "center",
              };
    if(props.first)
    {
        styles.borderTopRightRadius = 6;
        styles.borderTopLeftRadius  = 6;
    }
    if(props.last)
    {
        styles.borderBottomRightRadius = 6;
        styles.borderBottomLeftRadius  = 6;
    }
    const gridItemsCount = Math.max(Math.floor(12/props.btns.length),3);
    return <>
        <div style={styles}>
            <Container maxWidth="md">
                <Typography variant="h3" component="h2">{props.title}</Typography>
                <p>{props.txt}</p>
            </Container>
            <Container maxWidth="lg">
                <p>{props.btns.prop1}</p>
                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="stretch"
                    spacing={7}
                    style={{marginTop:30}}
                >
                    {props.btns.map((btn) => (
                    <Grid item sm={gridItemsCount} xs={12} style={{paddingBottom:btn.txt?72:20,position:"relative"}}>
                        <img src={btn.img} alt={btn.alt} style={{
                            height:    120,
                            marginBottom: 20
                        }}/>
                        <Typography variant="h6" component="h3">{btn.h}</Typography>
                        <p style={{textAlign:"justify",maxWidth:300,marginLeft:"auto",marginRight:"auto"}}>{btn.p}</p>
                        {btn.url && btn.url.indexOf("://") < 0  && btn.txt && <span style={{position:"absolute",bottom:28,left:0,right:0}}><Link to={btn.url}>               <Button variant="outlined" color="primary" size="large" style={{}}>{btn.txt}</Button></Link></span>}
                        {btn.url && btn.url.indexOf("://") >= 0 && btn.txt && <span style={{position:"absolute",bottom:28,left:0,right:0}}><a target="_blank" href={btn.url}><Button variant="outlined" color="primary" size="large" style={{}}>{btn.txt}</Button></a></span>}
                    </Grid>
                    ))}
                </Grid>
            </Container>
        </div>
    </>;
};
